import React, { forwardRef, useEffect, useState } from 'react'
import images from 'assets/img'
import Flags from 'country-flag-icons/react/3x2'
import CountrySelectionSm from './CountrySelectionSm'
import UserInfo from './UserInfo'
import Notifications from './Notifications'
import { Bell, Menubar } from 'assets/icons'
import Btn from 'components/Btn'
import { useDispatch, useSelector } from 'react-redux'
import ClickAwayComponent from 'components/ClickAwayComponent'
import Sidebar from '../Sidebar'
import { setLoading, showSidebar } from 'store/slices/miscSlice'
import getWindowDimensions from 'Helper'
import {UilAngleDown} from '@iconscout/react-unicons'
import useSWR from 'swr'

export default function Nav() {
  const {sidebar} = useSelector(state => state.misc)
  const [lang, setLang] = useState(null)
  const {data: user} = useSWR('auth/me')
  const dispatch = useDispatch()
  
  

  useEffect(() => {
    if (user) dispatch(setLoading('close'))
    else dispatch(setLoading())
  }, [user, dispatch])

  
  useEffect(() => {
    const lang = localStorage.getItem('__ra_pos_lang')
    if (lang) setLang(lang)
    else setLang('Nigeria')
  }, []);
  

  const { width } = getWindowDimensions()

  const switchLang = (lang) => {
    localStorage.setItem('__ra_pos_lang', lang)
    setLang(lang)
  }

  return (
    <>
      <div className="w-full flex justify-between h-16 p-3 bg-white shadow-sm z-10 fixed top-0 left-0">
        <div className="w-2/4 pt-2 flex item-center">
          <ClickAwayComponent 
            Component={forwardRef(({ handleClick, open }, ref) => <>
              <li className="inline-block relative" ref={ref}>
                <Btn 
                  className="rounded-md p-2.5 flex relative hover:bg-input"
                  content={ () => <Menubar classList="h-6 w-16 -ml-6 -mb-2" /> }
                  click={ () => {
                      handleClick()
                      dispatch(!sidebar ? showSidebar() : showSidebar('close'))
                    }
                  }
                />

                <Sidebar />
              </li>
            </>)
            }
          />
          
          {
            width <= 360 ? null : <img src={images.Logo} alt="Reachafrika logo" className="ml-2" />
          }
        </div>

        <ul className="w-1/4 flex justify-end">
          <ClickAwayComponent 
            Component={forwardRef(({ handleClick, open }, ref) => <>
              <li className="inline-block mx-3 relative" ref={ref}>
                <Btn 
                  className="w-10 h-10 p-0 rounded-full flex bg-default hover:bg-default"
                  content={ () => <Bell classList="w-6 h-6" /> }
                  click={ handleClick }
                />

                {
                  open && <Notifications handleClick={handleClick} />
                }
              </li>
            </>)
            }
          />

          <ClickAwayComponent 
            Component={forwardRef(({ handleClick, open }, ref) => <>
              <li className="inline-flex items-center mx-3 relative" ref={ref }>
                <Btn 
                  className="p-0 text-body-text flex bg-transparent hover:bg-transparent"
                  content={ () => <div className="flex items-center">
                      <span className="rounded-full text-white font-bold bg-failure w-10 h-10 block overflow-hidden text-lg p-1.5">{`${user?.data?.first_name[0]}${user?.data?.last_name[0]}`}</span> 
                      <UilAngleDown className="ml-1" />
                    </div>
                  }
                  click={ handleClick }
                />

                {
                  open && <UserInfo user={user?.data} />
                }
              </li>
            </>)
            }
          />

          <ClickAwayComponent 
            Component={forwardRef(({ handleClick, open }, ref) => <>
              <li className="hidden lg:inline-block mx-3" ref={ref }>
                <Btn 
                  className="w-14 h-10 p-0 hover:bg-transparent"
                  content={ () => <span className="flex items-center text-body-text">
                      {
                        lang === 'Nigeria' ? (
                          <Flags.NG title="Nigeria" className="h-7 w-7" /> 
                        ) : null
                      }
                      {
                        lang === 'Ghana' ? (
                          <Flags.NG title="Nigeria" className="h-7 w-7" /> 
                        ) : null
                      }
                      {
                        lang === 'Togo' ? (
                          <Flags.TG title="Togo" className="h-7 w-7" /> 
                        ) : null
                      }
                      
                      <UilAngleDown className="ml-1" />
                    </span>
                  }
                  click={ handleClick }
                />

                {
                  open && <CountrySelectionSm switchLang={switchLang} />
                }
              </li>
            </>)
            }
          />
        </ul>
      </div>
    </>
  )
}
